export const AuthConstants = {
  START_LOGIN_REQUEST: "START_LOGIN_REQUEST",
  START_LOGIN_SUCCESS: "START_LOGIN_SUCCESS",
  START_LOGIN_ERROR: "START_LOGIN_ERROR",

  CHECK_SCA_REQUEST: "CHECK_SCA_REQUEST",
  CHECK_SCA_SUCCESS: "CHECK_SCA_SUCCESS",
  CHECK_SCA_ERROR: "CHECK_SCA_ERROR",

  SELECT_IDENTIFICATION_REQUEST: "SELECT_IDENTIFICATION_REQUEST",
  SELECT_IDENTIFICATION_SUCCESS: "SELECT_IDENTIFICATION_SUCCESS",
  SELECT_IDENTIFICATION_ERROR: "SELECT_IDENTIFICATION_ERROR",

  RESET_LOGIN: "RESET_LOGIN",

  GET_IDENTIFICATION_URL_REQUEST: "GET_IDENTIFICATION_URL_REQUEST",
  GET_IDENTIFICATION_URL_SUCCESS: "GET_IDENTIFICATION_URL_SUCCESS",
  GET_IDENTIFICATION_URL_ERROR: "GET_IDENTIFICATION_URL_ERROR",

  REFRESH_TOKEN_REQUEST: "REFRESH_TOKEN_REQUEST",
  REFRESH_TOKEN_SUCCESS: "REFRESH_TOKEN_SUCCESS",
  REFRESH_TOKEN_ERROR: "REFRESH_TOKEN_ERROR",

  BIOFACE_LOGIN_SIDE_EFFECTS: "BIOFACE_LOGIN_SIDE_EFFECTS"
};
